import React, { Component, useRef } from 'react';
import { StandaloneSearchBox } from '@react-google-maps/api';
import { Input } from 'antd';

import { useGoogleMapsApi } from '../../utils/googleMaps';

const getAddressComponent = (addressComponents, field) => {
  const result = addressComponents.find(item => item.types.includes(field));
  return result ? result.long_name : '';
};

const emitPlaceValue = (places, separate, onChange) => {
  if (!places || places.length === 0) return;

  if (separate) {
    const addressComponents = places[0].address_components || [];
    const streetNumber = getAddressComponent(addressComponents, 'street_number');
    const streetName = getAddressComponent(addressComponents, 'route');
    const city = getAddressComponent(addressComponents, 'locality');
    const postcode = getAddressComponent(addressComponents, 'postal_code');
    const state = getAddressComponent(addressComponents, 'administrative_area_level_1');
    const country = getAddressComponent(addressComponents, 'country');
    onChange({ address: `${streetNumber} ${streetName}`.trim(), city, postcode, state, country });
    return;
  }

  onChange(places[0].formatted_address || '');
};

const AddressInput = ({ value, placeholder, disabled, onFocus, onChange, inputRef }) => (
  <Input
    ref={inputRef}
    value={typeof value === 'string' ? value : value?.address || ''}
    placeholder={placeholder}
    disabled={disabled}
    onChange={(e) => onChange(e.target.value)}
    onFocus={onFocus}
  />
);

const AddressSearchBoxComponent = ({ value, placeholder, disabled, onFocus, separate, onChange, bounds }) => {
  const searchBoxRef = useRef(null);
  const inputRef = useRef(null);
  const { isLoaded } = useGoogleMapsApi();

  const onPlacesChanged = () => {
    if (!searchBoxRef.current) return;
    emitPlaceValue(searchBoxRef.current.getPlaces(), separate, onChange);
  };

  // Always allow typing — even while Maps is still loading / failed to load.
  if (!isLoaded) {
    return (
      <AddressInput
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onFocus={onFocus}
        onChange={onChange}
        inputRef={inputRef}
      />
    );
  }

  return (
    <div data-standalone-searchbox="">
      <StandaloneSearchBox
        onLoad={(ref) => {
          searchBoxRef.current = ref;
        }}
        bounds={bounds}
        onPlacesChanged={onPlacesChanged}
      >
        <AddressInput
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={onFocus}
          onChange={onChange}
          inputRef={inputRef}
        />
      </StandaloneSearchBox>
    </div>
  );
};

export default class AddressSearchBox extends Component {
  onAddressChange = e => {
    const value = e && e.target ? e.target.value : e;
    const { onChange } = this.props;
    if (onChange) onChange(value);
  };

  render() {
    const { value, placeholder, disabled, onFocus, separate, bounds } = this.props;
    return (
      <AddressSearchBoxComponent
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={this.onAddressChange}
        onFocus={onFocus}
        separate={separate}
        bounds={bounds}
      />
    );
  }
}
